export enum Severity {
    Error = 'ERROR', Warning = 'WARN'
}
